module.exports = __webpack_public_path__ + "img/about-selfesthe.52756430.png";